module.exports = __webpack_public_path__ + "static/img/Tom-Dearden.4ec5db6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tom-Dearden.jpg
// module id = X7q8
// module chunks = 0